
    <h4 mat-dialog-title>Comment</h4>
    <div mat-dialog-content class="">
      <div class="">
        <p class="mb-2">Site: <strong>{{request.siteName}}</strong></p>
        <p>Unit: <strong>{{request.bridgeAdUnitName}}</strong></p>
      </div>
	    <mat-divider></mat-divider>
	    <mat-form-field class="w-100 mt-3">
        <textarea matInput
                  (keyup.enter)="request.comment && submit()"
                  [(ngModel)]="request.comment" style="min-height: 150px "
                  placeholder="Enter comment here"></textarea>
      </mat-form-field>
    </div>
    <div mat-dialog-actions class="justify-content-center">
      <button mat-raised-button color="" class="mr-1" [mat-dialog-close]="false">Close</button>
	    <button mat-raised-button color="primary" [disabled]="!request.comment"
	            class="mr-1" (click)="request.comment && submit()">Submit
	    </button>
    </div>
  